import type { FC } from "react"
import { IconLink3Outline18 as Link3 } from "nucleo-ui-outline-18"

import type { HelpCenterArticle, HelpCenterGroup } from "@productlane/zero"
import { IconButton, NewRequestIcon } from "@productlane/ui"
import {
	DropdownMenu,
	DropdownMenuItem,
} from "@productlane/ui/src/components/internal/dropdown"

import {
	VISIBILITY_MENU_WIDTH_CLASS,
	VISIBILITY_OPTION_ROW_NO_CHECK_CLASS,
	VisibilityOptionRow,
} from "@/components/shared/visibility-option-row"
import { LINK_ARTICLE_OPTION } from "./article-kind"
import {
	ARTICLE_VISIBILITY_OPTIONS,
	VISIBILITY_ICONS,
} from "./article-visibility"
import { useCreateArticle } from "./use-create-article"

interface AddArticleButtonProps {
	className?: string
	activeArticleId?: string | null
	articleGroups: readonly (HelpCenterGroup & {
		helpCenterArticles: readonly HelpCenterArticle[]
	})[]
}

export const AddArticleButton: FC<AddArticleButtonProps> = ({
	className,
	activeArticleId,
	articleGroups,
}) => {
	const createArticle = useCreateArticle({ articleGroups, activeArticleId })

	return (
		<DropdownMenu
			className={VISIBILITY_MENU_WIDTH_CLASS}
			contentProps={{ side: "bottom", align: "end" }}
			// No Tooltip wrapper: it takes over the trigger element and the menu
			// stops opening. The two menu items say what the button does anyway.
			trigger={
				<IconButton
					Icon={NewRequestIcon}
					iconClassName="h-[13px] w-[13px] !text-primary -translate-x-[0.5px]"
					variant="outline"
					aria-label="Create new article"
					className={className}
				/>
			}
		>
			{ARTICLE_VISIBILITY_OPTIONS.map((option) => {
				const Icon = VISIBILITY_ICONS[option.value]
				return (
					<DropdownMenuItem
						key={option.value}
						className={VISIBILITY_OPTION_ROW_NO_CHECK_CLASS}
						onSelect={() => createArticle({ visibility: option.value })}
					>
						<VisibilityOptionRow
							mark={<Icon className="h-3.5 w-3.5 flex-none text-tertiary" />}
							label={`${option.label} article`}
							description={option.description}
							isSelected={null}
						/>
					</DropdownMenuItem>
				)
			})}
			<DropdownMenuItem
				className={VISIBILITY_OPTION_ROW_NO_CHECK_CLASS}
				onSelect={() => createArticle({ kind: "LINK" })}
			>
				<VisibilityOptionRow
					mark={<Link3 className="h-3.5 w-3.5 flex-none text-tertiary" />}
					label={LINK_ARTICLE_OPTION.label}
					description={LINK_ARTICLE_OPTION.description}
					isSelected={null}
				/>
			</DropdownMenuItem>
		</DropdownMenu>
	)
}
